import { Provider, ErrorBoundary } from '@rollbar/react';
import isEmpty from "lodash/isEmpty";

function withRollbar(Component) {

    function ComponentWithRollbar(props) {
        if(!isEmpty(window.ROLLBAR_CONFIG)) {
            return (
                <Provider config={window.ROLLBAR_CONFIG}>
                    {/* ErrorBoundary catches all React errors in the tree below and logs them to Rollbar */}
                    <ErrorBoundary>
                        <Component {...props}/>
                    </ErrorBoundary>
                </Provider>
            );
        }
        return <Component {...props}/>
    }

    return ComponentWithRollbar;
}

export default withRollbar;